import styled, { css } from "styled-components/native";
import { mid_blue, void_color } from "../../StyleHelpers";
import { isRHD } from "../../utils/Utils";

const StyledController = styled.View`
	background-color: ${void_color};
	width: 100%;
	height: 120.5px;
	bottom: 0;
	left: 0;
	position: fixed;
	z-index: -1;
	border-top-width: 1px;
	border-style: solid;
	border-color: ${mid_blue};
	justify-content: center;
`;

const StyledControllerNarrow = styled.View<any>`
	position: ${(props) => (props.isStudioAccess ? "fixed" : "absolute")};
	background: ${(props) => (props.isLoading ? "rgba(192, 192, 192, 0.2)" : "rgba(10, 29, 57, 0.85)")};
	backdrop-filter: blur(5px);
	height: calc(100vh - 80px);
	width: 300px;
	top: ${(props) => (props.isStudioAccess || props.isAggregate ? 80 : 0)}px;
	left: 0px;
	display: flex;
	padding: 16px;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	z-index: ${(props) => (props.isStudioAccess ? 9999 : 0)};

	${(props) =>
		(props.isStudioAccess || props.isAggregate) &&
		css`
			background: transparent;
			padding: 0;
		`}

	${(props) =>
		props.isStudioAccess &&
		!props.isAggregate &&
		!props.isRHD &&
		css`
			left: 80px;
		`}
`;

// @ts-ignore
const ControllerContainer = (props) => {
	return (
		// @ts-ignores
		props?.isNarrow ? (
			<StyledControllerNarrow isRHD={isRHD()} isLoading={props.isLoading} isStudioAccess={props.isStudioAccess} isAggregate={props.isAggregate}>
				{props.children}
			</StyledControllerNarrow>
		) : (
			// @ts-ignores
			<StyledController>{props.children}</StyledController>
		)
	);
};

export default ControllerContainer;
